import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';

class Main extends Component {
  render(props) {
    const { user, isAuthenticated } = this.props.auth;
    return (
      <Container fluid>
        <h1>Профиль пользователя {user && user.username}</h1>
      </Container>
    );
  };
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, {})(Main);